<template>
    <div class="muven-top-progress"
        :class="{ 'is-visible': state.visible }"
        aria-hidden="true">
        <div class="muven-top-progress-bar"
            :style="{ width: `${state.progress * 100}%` }"></div>
    </div>
</template>

<script>
import { topProgressState } from '@/utils/services/TopProgressService';

export default {
    name: 'TopProgressCmp',
    data() {
        return {
            state: topProgressState,
        }
    },
}
</script>

<style lang="scss" scoped>
.muven-top-progress {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 100001;
    height: 3px;
    pointer-events: none;
    opacity: 0;
    transition: opacity .25s ease;

    &.is-visible {
        opacity: 1;
    }
}

.muven-top-progress-bar {
    // width em vez de scaleX para o "cometa" da ponta nao achatar; elemento fixo de 3px, custo irrelevante
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 0;
    background: linear-gradient(90deg, var(--brand-solid), var(--brand-fill) 60%, var(--brand-strong));
    border-radius: 0 3px 3px 0;
    transition: width .3s cubic-bezier(.22, 1, .36, 1);

    // "cometa" na ponta da barra
    &::after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        width: 80px;
        max-width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, color-mix(in srgb, var(--white) 55%, transparent));
        box-shadow: 0 0 10px color-mix(in srgb, var(--shadow-ink) 60%, transparent), 0 0 4px color-mix(in srgb, var(--shadow-ink) 50%, transparent);
        border-radius: inherit;
    }
}

@media (prefers-reduced-motion: reduce) {
    .muven-top-progress-bar {
        transition: none;

        &::after {
            display: none;
        }
    }
}
</style>
